import React from "react"
import { User } from "../../ZeefTypes"

interface UserSearchProps {
  searchQuery: string
  searchResults: User[]
  isSearching: boolean
  isFollowingUser: boolean
  onSearchChange: (event: React.ChangeEvent<HTMLInputElement>) => void
  onFollowUser: (userId: string) => void
}

const UserSearch: React.FC<UserSearchProps> = ({
  searchQuery,
  searchResults,
  isSearching,
  isFollowingUser,
  onSearchChange,
  onFollowUser,
}) => (
  <div className="user-search-section">
    <div className="search-input-container">
      <input
        type="text"
        placeholder="Search users to follow..."
        value={searchQuery}
        onChange={onSearchChange}
        className="form-control user-search-input"
      />
      {isSearching && <div className="search-loading">Searching...</div>}
    </div>

    {searchResults.length > 0 && (
      <div className="search-results">
        <h6>Search Results</h6>
        <div className="search-results-list">
          {searchResults.map((user) => (
            <div key={user.id} className="search-result-item" onClick={() => onFollowUser(user.id)}>
              <div className="user-avatar-small">{user.username.substring(0, 2).toUpperCase()}</div>
              <div className="user-details-small">
                <div className="user-name-small">{user.username}</div>
                <div className="user-email-small">{user.email}</div>
              </div>
              <div className="follow-btn">{isFollowingUser ? "..." : "+"}</div>
            </div>
          ))}
        </div>
      </div>
    )}
  </div>
)

export default UserSearch
